import React, { useEffect, useState } from 'react';
import {
    Typography,
    Box,
    Grid,
    Button,
    Stack,
    Snackbar,
    Alert,
    Divider,
    Tabs,
    Tab,
    Autocomplete,
    FormControlLabel,
    Tooltip,
    FormControl,
    Radio,
    RadioGroup
} from '@mui/material';
import { Input } from '../../components/input';
import { Breadcrumb } from 'components';
import { RegisterForm } from './RegisterForm';
import {
    userData,
    newUserRegister,
    getRegisterUserDetails,
    createNewInternalUser,
    internalGetAllRegistration,
    standardQuoteSearch,
    getClientManagers,
    approveRejectRequest,
    externalGetAllRegistration
} from 'services';
import AddIcon from '@mui/icons-material/Add';
import { GenericTable } from './GenericTable';
import { ManageUserGrid } from './ManageUserGrid';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import RemoveIcon from '@mui/icons-material/Remove';
import { ClientNameDropdown } from 'modules/quote/custom_component/clientNameDropdown';
import moment from 'moment';
import { ManageAddress } from '../quote/Settings/Manage_Address/ManageAddress';
import { getExternalClientPermissions } from 'helpers/externalClientPermissions';

let clearStatus: any = false;
let isSubmit: any = false;
let selectedClientId: any = '';
let selectedManagerId: any = '';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface ClientOption {
    id: number;
    name: string;
    code?: string;
    buCode?: string;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const UserManagement = () => {
    const [empData, setEmpData] = useState<any>([]);
    const [clientInfo, setClientInfo] = useState<any>([]);
    const [getAllRegisterUser, setGetAllRegisterUser] = useState<any>([]);
    const [getClientManagerList, setGetClientManagerList] = useState<any>([]);
    const [userInfo, setUserInfo] = useState<any>();
    const [addNewUser, setAddNewUser] = useState(false);
    const [enableCheck, setEnableCheck] = useState(false);
    const [successRequest, setSuccessRequest] = useState(false);
    const [addUserCheck, setAddUserCheck] = useState(false);
    const [enableRadio, setEnableRadio] = useState("true");
    const [manageClientUsers, setManageClientUsers] = useState(false);
    const [manageAllUsers, setManageAllUsers] = useState(false);
    const [rejectRequest, setRejectRequest] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [warningMessage, setWarningMessage] = useState('');
    const [enteredName, setEnteredName] = useState('');
    const [value, setValue] = useState(0);
    const [selectedClientName, setSelectedClientName] = useState('');
    const [selectedASMName, setSelectedASMName] = useState('');
    const [selectedManageAddressClientId, setSelectedManageAddressClientId] = useState('');
    const [manageAddressRefreshKey, setManageAddressRefreshKey] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        rowsPerPage: 10,
        total: 0,
        data: [],
        isLoading: false,
        resetPage: 0
    });
    const [searchClientName, setSearchClientName] = useState('');

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;
    const externalClientPermissions = getExternalClientPermissions(labUserCheck?.ClientPermissions);
    const [selectedRowClientId, setSelectedRowClientId] = useState('');
    const selectedClientOption = clientInfo.find((item: any) => item.id === selectedClientId) || null;
    // The dropdown lists every client - only clients with ManageAllUsers/ManageUsers can actually manage users
    const selectedRowClientPermission = externalClientPermissions.find(
        (client) => String(client.ClientID) === String(selectedRowClientId)
    );
    const hasManagePermissionForSelectedClient = labUserCheck?.UserType !== 'External' ||
        !!(selectedRowClientPermission?.Permissions?.includes('ManageAllUsers') || selectedRowClientPermission?.Permissions?.includes('ManageUsers'));

    const resetSelectedFilters = () => {
        setSelectedClientName('');
        setSelectedASMName('');
        setSearchClientName('');
        selectedClientId = '';
        selectedManagerId = '';
        setClientInfo([]);
        setGetClientManagerList([]);
        if (isManageAddressTab) {
            setSelectedManageAddressClientId('');
            setManageAddressRefreshKey(prev => prev + 1);
            return;
        }
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        resetSelectedFilters();
        if (newValue === 2) {
            setAddNewUser(false);
        }
        setValue(newValue);
    };

    useEffect(() => {
        userData(0).then((res: any) => {
            setUserInfo(res.data);
        })
    }, [])

    useEffect(() => {
        if (labUserCheck?.UserType === 'External') {
            if (!userInfo?.userMap) return;

            const isVisibleClient = (id: any) => userInfo.userMap.some((client: any) => String(client.clientID) === String(id));

            // Keep whatever is already selected (e.g. picked on another page) instead of resetting to the managed/fallback client
            if (selectedRowClientId && isVisibleClient(selectedRowClientId)) return;

            // The client picked on another page (ViewQuote/OrderHistory) takes priority over the managed/fallback default
            const savedClientId = localStorage.getItem('selectedClientId');
            if (savedClientId && isVisibleClient(savedClientId)) {
                setSelectedRowClientId(savedClientId);
                return;
            }

            const managedClient = externalClientPermissions.find((client) =>
                client.Permissions?.includes('ManageAllUsers') || client.Permissions?.includes('ManageUsers')
            );
            const fallbackClient = userInfo?.userMap?.[0];
            setSelectedRowClientId(managedClient ? String(managedClient.ClientID) : (fallbackClient ? String(fallbackClient.clientID) : ''));
            return;
        }

        if (userInfo?.userMap !== null && Array.isArray(userInfo?.userMap)) {
            const adminItem = userInfo.userMap.find((item: any) => item.isAdmin === true);
            setSelectedRowClientId(adminItem?.clientID || '');
        }
    }, [userInfo, labUserCheck?.UserType, labUserCheck?.ClientPermissions, selectedRowClientId]);

    const updateEmpData = (data: any) => {
        setEmpData(data);
        let status: any = false;
        if (labUserCheck?.UserType === 'External') {
            status = (data?.firstName?.length > 0 && data?.lastName?.length > 0 && data?.emailId?.length > 0 && (!data?.status));
            setEnableCheck(status);
        } else {
            status = (data?.firstName?.length > 0 && data?.lastName?.length > 0 && data?.emailId?.length > 0 && (data?.clientUserMaps?.length > 0) && (!data?.status));
            setEnableCheck(status);
        }
    }

    const submitData = (e: any) => {
        if (labUserCheck?.UserType === 'External') {
            submitExternalData(e);
        } else {
            submitInternalData(e);
        }
    }

    const submitExternalData = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        const params = {
            "clientId": selectedRowClientId,
            "loginName": empData?.emailId,
            "firstName": empData?.firstName,
            "lastName": empData?.lastName,
            "email": empData?.emailId,
            "phone": empData?.phoneNumber,
            "mobile": empData?.mobile,
            "isInvoiceEmail": false,
            "notes": empData?.notes,
            "RequesterID": userInfo?.id,
            "RequestedBy": labUserCheck?.given_name,
            "RequestedByEmailId": labUserCheck?.Email,
            "ClientName": externalClientPermissions.find((client) => String(client.ClientID) === String(selectedRowClientId))?.ClientName
        };

        newUserRegister(params).then((res: any) => {
            if (res.status === 200) {
                setAddNewUser(false);
                setSuccessRequest(true);
                setSuccessMessage(res.data);
                getExternalUserDetails();
            } else {
                setError(true);
                setErrorMessage(res.data);
            }
        })
    }

    const submitInternalData = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        const params = {
            "clientUserMaps": empData?.clientUserMaps,
            "firstName": empData?.firstName,
            "lastName": empData?.lastName,
            "email": empData?.emailId,
            "phone": empData?.phoneNumber,
            "mobile": empData?.mobile,
            "isInvoiceEmail": false,
            "notes": empData?.notes,
            "AddedBy": labUserCheck?.given_name,
            "AddedByEmailId": labUserCheck?.Email
        };
        createNewInternalUser(params).then((res: any) => {
            if (res.status === 200) {
                setAddNewUser(false);
                setSuccessRequest(true);
                setSuccessMessage(res.data);
                updateInternalRegisterUser();
            } else {
                setError(true);
                setErrorMessage(res.data);
            }
        })
    }

    const addNewUserApi = (id: any, status: any) => {
        let obj = {
            "id": id,
            "isApproved": status,
            "Approver": labUserCheck?.given_name,
            "ApproverId": parseInt(labUserCheck?.primarysid),
            "ApprovedByEmail": labUserCheck?.Email
        }
        approveRejectRequest(obj).then((res: any) => {
            if (res.status === 200) {
                updateInternalRegisterUser();
                setRejectRequest(true);
                setWarningMessage(res?.data?.message);
            } else {
                setError(true);
                setErrorMessage(res.data);
            }
        }).catch((error: any) => {
            setError(true);
            setErrorMessage(error.message || "An error occurred while processing the request.");
        });
    }

    const actionRender = (props: any) => {
        const { row } = props;
        return (
            <div style={{ display: 'inline-flex' }}>
                <Button variant="contained" color="primary" onClick={() => addNewUserApi(row.id, true)}>Approve</Button>
                <Button variant="outlined" color="error" onClick={() => addNewUserApi(row.id, false)} sx={{ marginLeft: '16px' }}>Reject</Button>
            </div>
        );
    }

    const renderNameCell = (props: any) => {
        const { row } = props;
        return (
            <div style={{ display: 'inline-flex' }}>
                {row.firstName} {row.lastName}
            </div>
        );
    }

    const renderClientName = (props: any) => {
        const { row } = props;
        return (
            <div>
                <Tooltip title={row.clientName}><span>{row.clientName}</span></Tooltip>
            </div>
        )
    }

    const renderInternalEmailCell = (props: any) => {
        const { row } = props;
        return (
            <div>
                <Tooltip title={row.email}>
                    <span>{row.email}</span>
                </Tooltip>
            </div>
        )
    }

    const interUserColumns = [
        {
            field: 'name',
            headerName: 'Name',
            minWidth: 150,
            renderCell: renderNameCell
        },
        {
            field: 'email',
            headerName: 'Email',
            minWidth: 200,
            renderCell: renderInternalEmailCell
        },
        {
            field: 'clientName',
            headerName: 'Client Name',
            minWidth: 200,
            renderCell: renderClientName
        },
        {
            field: 'requestedBy',
            headerName: 'Requested By',
            minWidth: 150
        },
        {
            field: 'requestedOn',
            headerName: 'Requested On',
            minWidth: 150,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={moment(params.row.requestedOn).format("DD/MM/YYYY")} arrow>
                        <span>{moment(params.row.requestedOn).format("DD/MM/YYYY")}</span>
                    </Tooltip>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            minWidth: 200,
            renderCell: actionRender
        }
    ];

    useEffect(() => {
        if (labUserCheck?.UserType === 'External' && hasManagePermissionForSelectedClient && !isSubmit) {
            getExternalUserDetails();
        }
    }, [hasManagePermissionForSelectedClient, labUserCheck?.UserType, selectedRowClientId, paginationModel?.page])

    useEffect(() => {
        if (userInfo?.id) {
            if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
                updateInternalRegisterUser();
                updateExternalManageUser();
            }
            getClientManager();
        }
    }, [userInfo])

    useEffect(() => {
        if (
            labUserCheck?.UserType === 'Internal' &&
            searchClientName.length >= 3 &&
            !selectedClientOption
        ) {
            clientInfoApi(searchClientName);
        }
    }, [searchClientName, selectedClientOption]);

    const clientInfoApi = (val: any) => {
        standardQuoteSearch(val).then((res: any) => {
            if (res.status === 200) {
                setClientInfo(res.data);
            } else {
                setClientInfo([]);
                setError(true);
                setErrorMessage(res.data);
            }
        })
    }

    useEffect(() => {
        if (userInfo?.id && !isSubmit) {
            updateExternalManageUser();
        }
    }, [paginationModel?.page])

    const getClientManager = () => {
        if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
            getClientManagers().then((res: any) => {
                if (res.status === 200) {
                    let itList: any = [];
                    res.data.map((el: any) => {
                        let obj = {
                            id: el.id,
                            name: el.fullName,
                            label: el.fullName
                        }
                        itList.push(obj)
                    })
                    setGetClientManagerList(itList);
                } else {
                    setError(true);
                    setErrorMessage(res.data);
                }
            })
        }
    }

    const handleClear = () => {
        clearStatus = true;
        isSubmit = true;
        setPaginationModel(old => ({ ...old, resetPage: 0, page: 0 }))
        setEnableRadio("true");
        setEnteredName('');
        resetSelectedFilters();
        if (isManageAddressTab) {
            setSelectedManageAddressClientId('');
            setManageAddressRefreshKey(prev => prev + 1);
            return;
        }
        setTimeout(() => {
            if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
                updateInternalRegisterUser();
                updateExternalManageUser();
            } else {
                getExternalUserDetails();
            }
        }, 100);
    }

    const updateInternalRegisterUser = () => {
        let permissionStatus = false;
        labUserCheck?.Permission?.map((item: any) => {
            if (labUserCheck?.Permission?.includes('AddUser')) {
                permissionStatus = true;
            }
        })
        let name = clearStatus ? '' : enteredName;
        if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
            internalGetAllRegistration(userInfo?.id, permissionStatus, selectedClientId, selectedManagerId, name).then((res: any) => {
                if (res.status === 200) {
                    setGetAllRegisterUser(res.data);
                } else {
                    setError(true);
                    setErrorMessage(res.data);
                }
            })
        }
    }

    const updateExternalManageUser = async () => {
        let permissionStatus = false;
        labUserCheck?.Permission?.map((item: any) => {
            if (labUserCheck?.Permission?.includes('AddUser')) {
                permissionStatus = true;
            }
        })
        let name = clearStatus ? '' : enteredName;
        let status = clearStatus ? true : enableRadio;
        let pageNo = isSubmit ? 0 : paginationModel?.page;
        if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
            await externalGetAllRegistration(userInfo?.id, permissionStatus, status, pageNo + 1, selectedClientId, selectedManagerId, name).then((res: any) => {
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        res.data.map((item: any) => {
                            setPaginationModel(old => ({ ...old, isLoading: false, data: res.data, total: item.totalRecordsCount }))
                        })
                    } else {
                        setPaginationModel(old => ({ ...old, isLoading: false, data: [], total: 0 }))
                    }
                    isSubmit = false;
                } else {
                    setError(true);
                    setErrorMessage(res.data);
                }
            })
        }
    }

    const getExternalUserDetails = () => {
        if (selectedRowClientId) {
            let name = clearStatus ? '' : enteredName;
            let status = clearStatus ? true : enableRadio;
            let pageNo = isSubmit ? 0 : paginationModel?.page;
            getRegisterUserDetails(status, selectedRowClientId, name, pageNo + 1).then((res: any) => {
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        res.data.map((item: any) => {
                            setPaginationModel(old => ({ ...old, isLoading: false, data: res.data, total: item.totalRecordsCount }))
                        })
                    } else {
                        setPaginationModel(old => ({ ...old, isLoading: false, data: [], total: 0 }))
                    }
                    isSubmit = false;
                } else {
                    setError(true);
                    setErrorMessage(res.data);
                }
            })
        }
    }

    const submitFilter = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        clearStatus = false;
        isSubmit = true;
        setPaginationModel(old => ({ ...old, resetPage: 0, page: 0 }));
        if ((labUserCheck && (labUserCheck?.UserType === 'Internal')) && value === 2) {
            setSelectedManageAddressClientId(selectedClientId || '');
            setManageAddressRefreshKey(prev => prev + 1);
            return;
        }
        setTimeout(() => {
            if ((labUserCheck && (labUserCheck?.UserType === 'Internal'))) {
                if (value === 0) {
                    updateInternalRegisterUser();
                } else if (value === 1) {
                    updateExternalManageUser();
                }
            } else {
                getExternalUserDetails();
            }
        }, 100);
    }

    useEffect(() => {
        if (labUserCheck && labUserCheck?.Permission) {
            if (Array.isArray(labUserCheck?.Permission)) {
                if (labUserCheck?.Permission?.includes('AddUser')) {
                    setAddUserCheck(true);
                }
                if (labUserCheck?.Permission?.includes('ManageClientUsers')) {
                    setManageClientUsers(true);
                }
                if (labUserCheck?.Permission?.includes('ManageClientUsers')) {
                    setManageAllUsers(true);
                }
            }
        }
    }, [labUserCheck])

    let intenalUserCheck = (labUserCheck?.Permission?.includes('StandardQuotes') || labUserCheck?.Permission === 'StandardQuotes') ? '/home/viewQuote' : '/home/admin';

    let pathChange = (labUserCheck && (labUserCheck?.UserType === 'Internal')) ? intenalUserCheck : '/home';

    let nav: any = [{ name: 'Home', path: pathChange }, { name: 'Admin', path: '/home/admin' }, { name: 'User Management', path: '/home/admin' }];

    const manageUser = () => {
        return <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
                <ManageUserGrid
                    setPaginationModel={setPaginationModel}
                    paginationModel={paginationModel}
                    labUserCheck={labUserCheck}
                    updateExternalManageUser={updateExternalManageUser}
                    getExternalUserDetails={getExternalUserDetails}
                />
            </Grid>
        </Grid>
    }

    const manageAddress = () => {
        return <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
                <ManageAddress
                    selectedClientId={selectedManageAddressClientId}
                    refreshKey={manageAddressRefreshKey}
                />
            </Grid>
        </Grid>
    }

    const handleStatusUser = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEnableRadio((event.target as HTMLInputElement).value);
    }

    const handleEnterName = (val: any) => {
        setEnteredName(val);
    }

    const formatClientOption = (client: ClientOption | string | null | undefined) => {
        if (typeof client === 'string') {
            return client;
        }

        if (!client) {
            return '';
        }

        return [client.name, client.code, client.buCode].filter(Boolean).join(' - ');
    };

    const isManageAddressTab = (labUserCheck && (labUserCheck?.UserType === 'Internal')) && value === 2;

    let girdSize = (labUserCheck && (labUserCheck?.UserType === 'Internal')) ? 9 : 8;

    let size: any = value === 0 ? 4 : 3;

    let FilterGirdSize = (labUserCheck && (labUserCheck?.UserType === 'Internal')) ? size : 6;
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left'>
                User Management
            </Typography>
            <Grid container spacing={2} style={{ marginBottom: '32px' }}>
                {labUserCheck?.UserType === 'External' || (labUserCheck && ((labUserCheck?.UserType === 'Internal' && addUserCheck))) ?
                    <>
                        {userInfo ?
                            <div style={{ marginLeft: '16px', marginTop: '24px' }}>
                                <ClientNameDropdown
                                    selectedClientId={selectedRowClientId}
                                    setSelectedClientId={setSelectedRowClientId}
                                    pageName="userManagement"
                                    setPaginationModel={() => { }}
                                />
                            </div> : null}
                        {!isManageAddressTab && hasManagePermissionForSelectedClient ?
                            <Grid item xs={12} sm={12} md={12} sx={{ textAlign: 'right', padding: 0 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={addNewUser ? <RemoveIcon /> : <AddIcon />}
                                    onClick={() => {
                                        setAddNewUser(prev => !prev);
                                    }}
                                >Add New User</Button>
                            </Grid> : null}
                    </>
                    : null}
                {addNewUser && !isManageAddressTab ? <>
                    <Grid item xs={12} sm={12} md={12} sx={{ textAlign: 'center' }}>
                        <Typography gutterBottom variant="h6" component="div">
                            Add New User
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} mb={2} sx={{ padding: '0' }}>
                        <form onSubmit={submitData}>
                            <RegisterForm
                                getEmpData={updateEmpData}
                                labUserCheck={labUserCheck}
                            />
                            <Grid container spacing={2} mt={2} sx={{ padding: '0 30%' }}>
                                <Grid item xs={12} sm={12} md={12} sx={{ textAlign: 'center' }}>
                                    <Button variant="contained" color="primary" startIcon={<ArrowCircleRightOutlinedIcon />} disabled={!enableCheck} type='submit'>{(labUserCheck && (labUserCheck.UserType !== 'Internal')) ? 'Submit Request' : 'Submit'}</Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                    <Divider sx={{ width: '100%', marginLeft: '8px', marginTop: '16px', marginBottom: '16px' }} />
                </> : null}
            </Grid>
            {hasManagePermissionForSelectedClient && <form onSubmit={(e: any) => submitFilter(e)} style={{ width: '100%' }}>
                <Grid container spacing={2} style={{ backgroundColor: '#f5f5f5', marginLeft: '0px', padding: '16px', borderRadius: '6px', width: '100%' }}>
                    <Grid item xs={12} sm={12} md={isManageAddressTab ? 4 : girdSize}>
                        <Grid container spacing={2}>
                            {!isManageAddressTab ?
                                <Grid item xs={4} sm={4} md={FilterGirdSize} style={{ padding: '0px 8px' }}>
                                    <Input
                                        label="Name"
                                        size="small"
                                        sx={{
                                            '.MuiInputLabel-root': {
                                                fontSize: '12px'
                                            },
                                            width: '100%'
                                        }}
                                        value={enteredName}
                                        onChange={(event: any) => handleEnterName(event.target.value)}
                                    />
                                </Grid> : null}

                            {(manageClientUsers || manageAllUsers || isManageAddressTab) ?
                                <Grid item xs={12} sm={12} md={isManageAddressTab ? 12 : size} style={{ padding: '0px 8px' }}>
                                    <Autocomplete
                                        id="controlled-demo"
                                        options={clientInfo}
                                        value={selectedClientOption}
                                        size="small"
                                        sx={{
                                            '.MuiInputLabel-root': {
                                                fontSize: '12px'
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.id === value?.id
                                        }
                                        getOptionLabel={(option) => formatClientOption(option)}
                                        onChange={(event, newValue) => {
                                            setSelectedClientName(newValue || '');
                                            selectedClientId = newValue?.id || '';
                                        }}
                                        onInputChange={(event, newInputValue, reason) => {
                                            if (reason === 'input') {
                                                setSearchClientName(newInputValue);
                                            }

                                            if (newInputValue.length === 0) {
                                                selectedClientId = '';
                                                setSelectedClientName('');
                                                setSearchClientName('');
                                                setClientInfo([]);
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.id}>
                                                {formatClientOption(option)}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <Input
                                                {...params}
                                                label="Client Name"
                                            />
                                        )}
                                    />
                                </Grid> : null}
                            {!isManageAddressTab && manageAllUsers ?
                                <Grid item xs={4} sm={4} md={size} style={{ padding: '0px 8px' }}>
                                    <Autocomplete
                                        freeSolo
                                        id="free-solo-3-demo"
                                        options={getClientManagerList}
                                        value={selectedASMName}
                                        size="small"
                                        sx={{
                                            '.MuiInputLabel-root': {
                                                fontSize: '12px'
                                            }
                                        }}
                                        onChange={(event: any, newValue: any) => {
                                            setSelectedASMName(newValue.name);
                                        }}
                                        onInputChange={(event: any, newInputValue: any) => {
                                            getClientManagerList.map((item: any, key: any) => {
                                                if (item.name === newInputValue) {
                                                    selectedManagerId = item.id;
                                                }
                                            })
                                            if (newInputValue.length === 0) {
                                                selectedManagerId = ''
                                                setSelectedASMName('');
                                            }
                                        }}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option?.id}>
                                                    {option?.name}
                                                </li>
                                            );
                                        }}
                                        renderInput={(params) => <Input {...params} label="ASM Name" />}
                                    />
                                </Grid> : null}
                            {!isManageAddressTab && ((value !== 0) || (labUserCheck?.UserType !== 'Internal')) ?
                                <Grid item xs={8} sm={8} md={size} style={{ padding: '0px 8px' }}>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            value={enableRadio}
                                            onChange={handleStatusUser}
                                        >
                                            <FormControlLabel value="true" control={<Radio />} label="Active" />
                                            <FormControlLabel value="false" control={<Radio />} label="Inactive Users" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                : null}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} style={{ padding: '0px 8px' }} sx={{ mt: { xs: 2, sm: 1, md: 0 }, textAlign: isManageAddressTab ? 'right' : 'left' }}>
                        <Button variant="contained" color="primary" startIcon={<ContentPasteSearchOutlinedIcon />} type="submit">Search</Button>
                        <Button variant="outlined" color="primary" startIcon={<ClearOutlinedIcon />} onClick={handleClear} sx={{ marginLeft: '8px' }}>Clear All</Button>
                    </Grid>
                </Grid>
            </form>}
            {(labUserCheck && (labUserCheck?.UserType === 'Internal')) ?
                <>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: '8px' }}>
                            <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example" id="tabId">
                                <Tab label="Registration Requests" {...a11yProps(0)} />
                                <Tab label="Manage Users" {...a11yProps(1)} />
                                <Tab label="Manage Address" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <GenericTable
                                        columns={interUserColumns}
                                        rows={getAllRegisterUser}
                                    />
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            {manageUser()}
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            {manageAddress()}
                        </TabPanel>
                    </Box>
                </>
                : <div style={{ width: "100%", marginTop: '24px' }}>
                    {!selectedRowClientId ? null : hasManagePermissionForSelectedClient ? manageUser() : (
                        <Alert severity="warning" sx={{ mt: 2 }}>
                            You don't have permission to manage users for this client. Please reach out to the admin to provide access for this client.
                        </Alert>
                    )}
                </div>}
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={successRequest} autoHideDuration={6000} onClose={() => setSuccessRequest(false)}>
                    <Alert severity="success" onClose={() => setSuccessRequest(false)}><b>{successMessage}</b></Alert>
                </Snackbar>
                <Snackbar open={rejectRequest} autoHideDuration={6000} onClose={() => setRejectRequest(false)}>
                    <Alert severity="success" onClose={() => setRejectRequest(false)}><b>{warningMessage}</b></Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert severity="error" onClose={() => setError(false)}><b>{errorMessage}</b></Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
